function uploadError({ input, state }) {
  let path = input.path
  state.merge(path, {
    errorMessage: { key: 'bus-client.errors.uploadError' },
    isValid: false
  })
  state.merge(path.concat('.value'), { uploadDone: false, error: true })
}

export default uploadError



// WEBPACK FOOTER //
// ./src/modules/user/actions/uploadError.js